import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-of-service',
  standalone: false,
  templateUrl: './terms-of-service.html',
  styleUrls: ['../legal.css']
})
export class TermsOfService {
  lastUpdated = 'December 6, 2025';
}
